export default __webpack_public_path__ + "static/media/berth.4c690774.svg";